export enum HorseShareActionResponseTypeEnum {
  HORSE_SHARED,
  HORSE_SHARE_ACTION_FAILED,
  HORSE_SHARE_DEACTIVATED,
  HORSE_SHARE_REACTIVATED,
  HORSES_BATCH_SHARED,
}

